import React, { Component } from 'react'

class SearchItemDate extends Component {
	getPostDate = () => {
		// Validation robuste des props
		if (!this.props.postItem || !this.props.postItem._source) {
			return ''
		}

		try {
			let dateBegin
			
			if (this.props.postItem._source.post_type === 'events-openagenda' && this.props.postItem._source.date_begin_timestamp) {
				dateBegin = new Date(this.props.postItem._source.date_begin_timestamp * 1000)
			} else if (this.props.postItem._source.post_date) {
				dateBegin = new Date(this.props.postItem._source.post_date)
			} else {
				return ''
			}

			return new Intl.DateTimeFormat('fr-FR', {day: '2-digit', month: 'long', year: 'numeric'}).format(dateBegin)
		} catch (error) {
			console.warn('Erreur lors du formatage de la date:', error)
			return ''
		}
	}

	getPostDatesClass = () => {
		if (this.props.postItemMini) {
			return 'search-list-item-date search-list-mini-item-date'
		}
		return 'search-list-item-date'
	}

	render = () => {
		const postDate = this.getPostDate()
		
		// Ne rendre que si la date existe
		if (!postDate) {
			return null
		}

		return (
			<p 
				className={this.getPostDatesClass()}
				role="text"
				aria-label={`Date de publication: ${postDate}`}
			>
				<span>{postDate}</span>
			</p>
		)
	}
}

export default SearchItemDate;
